var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 248.194,
    height: 238.903,
    viewBox: "0 0 248.194 238.903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people_love_us_icon1",
    transform: "translate(82.698 -47.746) rotate(30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_171869",
    "data-name": "\\uADF8\\uB8F9 171869",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_8",
    "data-name": "\\uB2E4\\uAC01\\uD615 8",
    transform: "translate(0 165.395) rotate(-60)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.237,0l47.745,82.8-47.745,82.8H47.745L0,82.8,47.746,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62.76579284667969 26 L 30.01300048828125 82.79915618896484 L 62.76579284667969 139.5983123779297 L 128.2162170410156 139.5983123779297 L 160.968994140625 82.79915618896484 L 128.2162170410156 26 L 62.76579284667969 26 M 47.7454833984375 0 L 143.2365417480469 0 L 190.9819946289062 82.79915618896484 L 143.2365417480469 165.5983123779297 L 47.7454833984375 165.5983123779297 L -1.52587890625e-05 82.79915618896484 L 47.7454833984375 0 Z",
    stroke: "none",
    fill: "#dde5ef"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagon);
export default __webpack_public_path__ + "static/media/hexagon.c5119f0248ba6a67cd2aaf348837362c.svg";
export { ForwardRef as ReactComponent };